const steps = [
  { n: "01", t: "Diagnóstico", d: "Audito tu operación, ads y procesos comerciales para encontrar fugas de leads y dinero." },
  { n: "02", t: "Estrategia", d: "Diseño el sistema: canales, flujos de IA, automatizaciones y plan de Ads con KPIs claros." },
  { n: "03", t: "Implementación", d: "Yo opero. Configuro Respond.io, bots, integraciones, campañas y entreno a tu equipo." },
  { n: "04", t: "Optimización", d: "Iteración semanal sobre datos: creatividades, copys, audiencias, flujos y conversión." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 sm:py-32">
      <div className="container-x">
        <div className="max-w-2xl reveal">
          <div className="eyebrow mb-5">Proceso de trabajo</div>
          <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
            Cuatro pasos para pasar de <span className="text-gradient">caos a sistema</span>.
          </h2>
        </div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#ff8a00]/40 to-transparent" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {steps.map((s, i) => (
              <div key={s.n} className="reveal" style={{ transitionDelay: `${i * 80}ms` }}>
                <div className="relative">
                  <div className="w-24 h-24 rounded-full bg-[#0a0a0a] border border-white/10 grid place-items-center mx-auto lg:mx-0 mb-6 relative">
                    <div className="absolute inset-0 rounded-full bg-gradient-brand opacity-15 blur-md" />
                    <span className="font-display font-extrabold text-3xl text-gradient relative">{s.n}</span>
                  </div>
                </div>
                <h3 className="font-display font-bold text-white text-2xl tracking-tight">{s.t}</h3>
                <p className="mt-2.5 text-zinc-400 text-sm leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
